"use client";

import { HmcButton } from "@adi-ctx/harmonic-core-components-react";
import { Link, useAuth } from "@/components";
import type { TAuthContextType } from "@/components";
import { t } from "@/utils";
import { pathNames } from "@/lib/constants/pathNames.constants";
import { RiLogoutBoxRLine } from "@remixicon/react";

export default function HeaderUser() {
	const { cognitoUserInfo: userInfo, isAuthenticated }: TAuthContextType =
		useAuth();

	return (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>
			{isAuthenticated && (
				<div className="hmc-body-xs ml-2 flex items-center whitespace-nowrap">
					<span
						data-testid="cms-header-navigation-user"
						className="text-sm font-semibold"
					>
						{userInfo?.givenName} {userInfo?.familyName}
					</span>
					<Link href={pathNames.cmsLogout}>
						<HmcButton
							isIconOnly
							kind="ghost"
							title={t("auth.logout")}
							data-testid="cms-header-navigation-button-logout"
							className="ml-2"
						>
							<RiLogoutBoxRLine data-testid="cms-header-navigation-icon-logout" />
							<span className="hidden">{t("auth.logout")}</span>
						</HmcButton>
					</Link>
				</div>
			)}
		</>
	);
}
